export function mobileStrIdCardUp (str) {
  if (str === null || str === 'undefined' || str === '') return null
  if (str.length !== 0) {
    return str.substring(0, 1) + '****************' + str.substring(17, str.length)
  } else {
    return null
  }
}

export function mobileStrPhoneUp (str) {
  if (str === null || str === 'undefined' || str === '') return null
  if (str.length !== 0) {
    return str.substring(0, 3) + '*****' + str.substring(8, str.length)
  } else {
    return null
  }
}
